import { History } from "lucide-react";
import { formatCurrency } from "../../lib/utils";
import { reasonLabel } from "./salaryReasons";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-PT") : "—");

export const SalaryHistoryList = ({ history }) => (
  <div className="border-t pt-3 mt-1" data-testid="salary-history">
    <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground flex items-center gap-1 mb-2"><History className="w-3.5 h-3.5" /> Histórico de ajustes ({history.length})</p>
    {history.length === 0 && <p className="text-xs text-muted-foreground">Ainda sem ajustes registados.</p>}
    <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
      {history.map((h) => (
        <div key={h.adjustment_id} className="rounded-md border p-2 text-xs" data-testid={`salary-history-${h.adjustment_id}`}>
          <div className="flex justify-between gap-2 flex-wrap">
            <span className="font-mono">{formatCurrency(h.previous_salary)} → <b>{formatCurrency(h.new_salary)}</b></span>
            <span className={`font-mono font-semibold ${h.difference >= 0 ? "text-emerald-600" : "text-red-600"}`}>
              {h.difference >= 0 ? "+" : "−"}{formatCurrency(Math.abs(h.difference))}{h.percent_change !== null && h.percent_change !== undefined ? ` (${h.percent_change > 0 ? "+" : ""}${h.percent_change}%)` : ""}
            </span>
          </div>
          <p className="mt-1"><b>{reasonLabel(h.reason_type)}</b> · {h.reason}</p>
          {h.notes && <p className="text-muted-foreground italic">Nota: {h.notes}</p>}
          <p className="text-muted-foreground mt-1">Efeito {fmt(h.effective_date)} · por {h.created_by_name || "—"} em {fmt(h.created_at)}</p>
        </div>
      ))}
    </div>
  </div>
);
